import { useEffect, useState } from "react";
import { useFormInternalContext } from "../utils/formContext.js";
function useFormMeta() {
  const { api } = useFormInternalContext();
  const [meta, setMeta] = useState(api.getMeta);
  useEffect(() => {
    let effectCleared = false;
    const unsubscribe = api.subscribeToMeta((meta2) => {
      if (effectCleared) return;
      setMeta(meta2);
    });
    return () => {
      effectCleared = true;
      unsubscribe();
    };
  }, [api]);
  return { meta, api };
}
export {
  useFormMeta
};
//# sourceMappingURL=useFormMeta.js.map
